import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { QuestWidgetDataType, WidgetEntry } from '../types';

export function useQuestWidgets() {
  const { questStore } = useStores();
  const { questsFlag, currentPlayerQuest } = questStore;

  const questWidgets: QuestWidgetDataType[] = useMemo(() => {
    if (!questsFlag || !currentPlayerQuest) {
      return [];
    }
    return [
      {
        key: 'quest',
        event: currentPlayerQuest,
        dataTestId: 'quest-widget',
      },
    ];
  }, [currentPlayerQuest, questsFlag]);

  return useMemo(
    () => questWidgets.map((data): WidgetEntry<'quest'> => ({ data, type: 'quest', id: data.key })),
    [questWidgets],
  );
}
